export const VEHICLE_CONFIGURATOR_EMPTY_CASE_ENABLED = false
export const MAX_RESULTS_FOR_CONFIGURATOR_EMPTY_CASE = 5

export const VEHICLE_CONFIGURATOR_ACTIONS = {}
export const VEHICLE_CONFIGURATOR_STEPS = {}

// Added because the client tests where failing even if the configurator was not enabled
export const FORM_FIELD_IDS = {
  ZIP_CODE: 'ZIP_CODE',
  PHONE: 'PHONE',
  OEM_LEGAL_CONSENTS: 'OEM_LEGAL_CONSENTS',
  NAME: 'NAME',
  EMAIL: 'EMAIL'
}

// Added because the client tests where failing even if the configurator was not enabled
export const VEHICLE_CONFIGURATOR_FIELDS_CONFIG = {
  [FORM_FIELD_IDS.ZIP_CODE]: {
    id: 'ZIP_CODE',
    type: 'INPUT',
    name: 'zipcode',
    label: 'COMMON.POSTAL_CODE',
    placeholder: 'MODAL_LAST_CALL.CP_PLACEHOLDER',
    inputMode: 'numeric',
    leftIcon: 'location',
    maxLength: 5,
    isRequired: true
  },
  [FORM_FIELD_IDS.PHONE]: {
    id: 'PHONE',
    type: 'INPUT',
    name: 'phone',
    label: 'COMMON.YOUR_PHONE',
    placeholder: 'FORM.CONTACT_PHONE_LABEL',
    inputMode: 'numeric',
    leftIcon: 'phone',
    maxLength: 15,
    isRequired: false
  },
  [FORM_FIELD_IDS.OEM_LEGAL_CONSENTS]: {
    id: 'OEM_LEGAL_CONSENTS',
    type: 'CHECKBOX',
    name: 'oemLegalConsents',
    label: null,
    placeholder: '',
    inputMode: 'checkbox',
    leftIcon: null,
    maxLength: null,
    isRequired: false
  },
  [FORM_FIELD_IDS.NAME]: {
    id: 'NAME',
    type: 'INPUT',
    name: 'name',
    label: 'FORM.CONTACT_NAME_LABEL',
    placeholder: 'FORM.CONTACT_NAME_LABEL',
    inputMode: 'text',
    leftIcon: 'user',
    maxLength: 50,
    isRequired: true
  },
  [FORM_FIELD_IDS.EMAIL]: {
    id: 'EMAIL',
    type: 'INPUT',
    name: 'email',
    label: 'FORM.EMAIL_LABEL',
    placeholder: 'FORM.EMAIL_PLACEHOLDER_EXAMPLE',
    inputMode: 'email',
    leftIcon: 'mail',
    maxLength: 100,
    isRequired: true
  }
}
